import {
  config
} from '../_config'
import {
  authHeader,
  handleResponse
} from '../_helpers'

export const expoPasarelasService = {
  addPasarelaRedsys,
  editPasarelaRedsys,
  addPasarelaPaypal,
  editPasarelaPaypal,
  addPasarelaTransfer,
  editPasarelaTransfer,
}


function addPasarelaRedsys(datos) {

  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoRedsys`, requestOptions).then(handleResponse)

}

function editPasarelaRedsys(datos) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoRedsys/${datos.id}`, requestOptions).then(handleResponse)

}

function addPasarelaPaypal(datos) {
  console.log(datos)

  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoPaypal`, requestOptions).then(handleResponse)

}

function editPasarelaPaypal(datos) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoPaypal/${datos.id}`, requestOptions).then(handleResponse)

}

function addPasarelaTransfer(datos) {

  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoTransferencia`, requestOptions).then(handleResponse)

}

function editPasarelaTransfer(datos) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoTransferencia/${datos.id}`, requestOptions).then(handleResponse)

}



function deleteExpoDateInscr(id) {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(datos)
  }

  return fetch(`${config.apiUrl}/expoDateInscr/${id}`, requestOptions).then(handleResponse)

}
